import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useToast } from '@/hooks/use-toast';
import { alterarSegmento, type AlterarSegmentoPayload } from '../api/ProdutoApi';

export function useAlterarSegmento() {
  const queryClient = useQueryClient();
  const { toast } = useToast();

  return useMutation({
    mutationFn: (payload: AlterarSegmentoPayload) => alterarSegmento(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['segregacao-calcular'] });
      toast({ title: 'Segmento alterado com sucesso.' });
    },
    onError: () => {
      toast({
        variant: 'destructive',
        title: 'Erro ao alterar segmento',
        description: 'Não foi possível completar a operação. Tente novamente.',
      });
    },
  });
}
